import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { GripVertical } from 'lucide-react';
import { initials } from '@/components/design';
import type { Participant } from '@/data/types';

interface Props {
  participant: Participant;
  index: number;
}

export function SortableParticipantRow({ participant, index }: Props) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: participant.id,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  const club = participant.players.map((p) => p.club).filter(Boolean).join(', ');

  return (
    <div
      ref={setNodeRef}
      style={style}
      className={`drag-row ${isDragging ? 'dragging' : ''}`}
      {...attributes}
      {...listeners}
    >
      <GripVertical size={16} className="drag-handle" />
      <span className="seed-num">№{index + 1}</span>
      <div className="av">{initials(participant.displayName)}</div>
      <div style={{ flex: 1 }}>
        <div style={{ fontSize: 14 }}>{participant.displayName}</div>
        {club && <div className="t-xs t-mute">{club}</div>}
      </div>
    </div>
  );
}
